if (!customElements.get('our-mission')) {
  customElements.define(
    'our-mission',
    class OurMission extends HTMLElement {
      selectors = {
        activeClass: 'active',
      }

      get textTabImages() {
        return Array.from(this.querySelectorAll('[data-tab-content]'));
      }

      get textTabButtons() {
        return Array.from(this.querySelectorAll('.js-text-block-tab'));
      }

      constructor() {
        super();
      }

      connectedCallback() {
        this.textTabButtons.forEach(button => button.addEventListener('mouseenter', (event) => {
          if (button.classList.contains(this.selectors.activeClass)) return;
          this.clearActives();

          button.classList.add(this.selectors.activeClass);
          const elTarget = this.querySelector(`#${button.dataset.target}`);
          elTarget?.classList.add(this.selectors.activeClass);
        }));
      }

      clearActives() {
        this.textTabButtons.forEach(el => {
          if (!el.classList.contains(this.selectors.activeClass)) return;
          el.classList.remove(this.selectors.activeClass);

          const elTarget = this.querySelector(`#${el.dataset.target}`);
          if (!elTarget || !elTarget.classList.contains(this.selectors.activeClass)) return;
          elTarget.classList.remove(this.selectors.activeClass);
        });
      }
    }
  )
}